import React,{useState,useRef,Fragment} from "react";
import { Col, Row, Button, Form, FormGroup, Label, Input, Container,Card,CardBody } from "reactstrap";
import Moment from 'moment';
import '../../../style/profilepic.css';
// import { Button } from "react-bootstrap";
import api from "../../../apis/api";
import { useEffect } from "react";
import moment from "moment";
import useFormValidation from "../../../components/common/useFormValidation";
import Notifications from "../../../components/common/Notifications";
import ChangePasswordModal from "../employeeProfileView/TabRewards/ChangePasswordModal";
import axios from "axios";
import Avatar from '@mui/material/Avatar';
var loginUser = JSON.parse(localStorage.getItem("user"));
const EmpProfileViewToCard = React.memo(({ selectEmp,profilepic }) => {
  const [src,setSrc]=useState([]);
  const [picture, setPicture] = useState(null);
  const [imgData, setImgData] = useState(null);
  const [isbuttonVisible,setisbuttonVisible]=useState(false);
  const [isdetailsedit,setisdetailsedit]=useState(false);
  const [phone,setphone]=useState("");
  const [email,setemail]=useState("");
  const [dob,setdob]=useState("");
  const [address,setaddress]=useState("");
  const [employeeDetails, setEmployeeDetails] = useState({});
  const [error, setError] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [inputFieldValues, setInputFieldValues] = useState(0);
  const fontSize = {
    fontSize: "12px",
  };
  const inputHeight = { height: "35px" };
  const [
    formValidationStateAssetItem,
    setFormValidationStateAssetItem,
  ] = useState({});
  const callValidationAssetItem = useRef(false);

  const { formValidation, isFormValid } = useFormValidation(
    formValidationStateAssetItem
  ); // for item inside asset.
  useEffect(() => {
    // calls when asset item's add&edit form is submited.
    callValidationAssetItem.current && callBackAfterValidationEmp();
  }, [formValidation]);
 
  useEffect(() =>{
    if(selectEmp.length !== 0)
    {
      setEmployeeDetails({
        ...selectEmp.value,
      
      });
      
      //  alert(process.env.PUBLIC_URL + '/img/employee/' + selectEmp.value.profilePicture);
    }
    // handelpic();
    // else{
    //   setphone("");
    //   setemail("");
    //   setaddress("");
    //   setdob("");
    // }
  },[selectEmp]);

  // useEffect(() => {
  //   const fetchImage = async () => {
  //     try {
  //       const response = await axios.get(`http://localhost:63307/api/Employee/GetProfilePic?employeeId=${parseInt(loginUser.EmployeeId)}`,
  //       {responseType: 'blob'});

  //       // Create a URL for the PNG file to use in an image tag
  //       const imageUrl = URL.createObjectURL(response.data);
  //       setPicture(`http://localhost:63307/UploadedPhotos/24ed109e-7fda-4708-b15f-022a5cf971be.png`);
  //     } catch (error) {
  //       console.error("Error fetching image:", error);
  //     }
  //   };

  //   fetchImage();
  // }, [loginUser,setPicture]);
  const onChange = (e)=>{
    if (e.target.files[0]) {
      const file = e.target.files[0];
      const maxSizeInBytes = 5 * 1024; // 5KB
  
      if (file && file.size > maxSizeInBytes) {
        setError({ ...error, message: "File size exceeds the limit of 5KB...", status: 500 });
      }
      else
      {
        setPicture(e.target.files[0]);
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          setImgData(reader.result);
        });
        reader.readAsDataURL(e.target.files[0]);
        setisbuttonVisible(true);
      }
      // console.log("picture: ", e.target.files);
     
    }
  }
  const toggleModal = () => setOpenModal((prevState) => !prevState);
  const onchangeInputField = (e) => {
    let updateInputValues = {
      ...inputFieldValues,
      [e.target.name]: e.target.value,
    };
    setInputFieldValues(updateInputValues);
  };
  const handleupdateprofilepic =React.useCallback(async (e) => {
    e.preventDefault();
    try{
       const formData= new FormData();
        // formData.append("employeeId", loginUser.EmployeeId);
        formData.append("file",picture);
        // formData.append("UploadPolicyFilePath",picture.name);
       
          // const response = await axios.post(`http://localhost:5000/api/EmployeePhoto/upload/${employeeId}`, formData, {
          //   headers: {
          //     'Content-Type': 'multipart/form-data',
          //   },
          // });
          const res=await api.dailytask().UpdateProfilePic(loginUser.EmployeeId,formData);
          setError({ ...error, message: "Profile Picture Updated Successfully..", status: 200 });
          // setPicture(res.data)
          window.location.reload();
          // console.log(res);
        }
        catch(ex)
        {
 
        }
  },[setPicture,picture])
  const handledetailseditable =() =>{
    setisdetailsedit((prevState) => !prevState);
  }
  const formValidationOnSubmitAddemp = React.useCallback(
    (e) => {
      e.preventDefault();
      let formValidationList = {
        // key name should be same as the input field name to represtent in form.
        primaryMailId: {
          required: true,
          isValid: true,
          value: employeeDetails.primaryMailId,
          errorMessage: "",
        },
       
      };
      setFormValidationStateAssetItem(formValidationList); //this set call the custom hook useFormValidation.
      callValidationAssetItem.current = true;
    },
    [employeeDetails]
  );
  const callBackAfterValidationEmp = React.useCallback(() =>{
    let empFormData = new FormData();
    empFormData.append("employeeId",employeeDetails.employeeId);
    empFormData.append("dateOFBirth",employeeDetails.dateOFBirth);
    empFormData.append("postalAddress",employeeDetails.postalAddress);
    empFormData.append("mobileNumber",employeeDetails.mobileNumber);
    empFormData.append("primaryMailId",employeeDetails.primaryMailId);

    const fetchApi = async () => {
      await api.dbqualification().AddEditEmployeeContactDetails(empFormData);
      setError({ ...error, message: "Employee Profile Successfully..", status: 200 });
      setisdetailsedit(false);
      let array=[];
      await api.employee().getSelectedEmployee(employeeDetails.employeeId).then((res) => array.push(res.data));
      setEmployeeDetails(array[0]);
      window.location.reload();
    }
    fetchApi();
  },[employeeDetails,setEmployeeDetails]);

  const handleOnChangePersonalInfoFields = React.useCallback(
    (field, value) => {
      let updateObj = employeeDetails;

      let updateValue = {
        ...updateObj,
        [field]: value,
      };
      setEmployeeDetails(updateValue);
      //console.log(updateValue);
    },
    [employeeDetails]
  );
  const handleSubmitPassword = React.useCallback(() => {
    //console.log(inputFieldValues);
    if(inputFieldValues!=0){
      let formData = {
        emailId: employeeDetails.userName,
        currentPassword: inputFieldValues.currentPassword,
        NewPassword:inputFieldValues.newPassword,
      };
    
       api.account().ChangePassword(formData).then((res) => {
          if (res.data.statusCode === 200) {
            toggleModal();
            setError({ ...error, message: "Password Changed Successfully..", status: 200 });
            setTimeout(() => { 
             localStorage.removeItem("user");
             window.location.href = "/em";
             window.sessionStorage.clear();
         }, 4000);
          }
          else
          {
            setError({ ...error, message: res.data.message, status: 500 });
          }
       
        })
   
        
    }
    
  }, [inputFieldValues]);
  const maskAadhar = (aadhar) => {
    if(aadhar != undefined)
     { 
      return aadhar.replace(/.(?=.{1})/g, '*') ;
     }
   }
  const personaldetails=(
    <Fragment>
      <Form>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
           Phone
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              style={inputHeight}
              value={employeeDetails.mobileNumber}
              onChange={(e) =>
                handleOnChangePersonalInfoFields(
                  "mobileNumber",
                  e.target.value
                )
              }
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
            Email
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              name="primaryMailId"
              value={employeeDetails.primaryMailId}
              onChange={(e) =>
                handleOnChangePersonalInfoFields(
                  "primaryMailId",
                  e.target.value
                )
              }
              style={inputHeight}
            />
              {
              // Object.keys(formValidation).length !== 0 &&
              !formValidation?.primaryMailId?.isValid && (
                <span className=" " style={{ color: "red" }}>
                  {formValidation?.primaryMailId?.errorMessage}
                </span>
              )
            }
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={4} style={fontSize}>
           Birthday
          </Label>
          <Col sm={8}>
          <Input
              type="date"
              // value="2018-07-22"
              value={
                employeeDetails.dateOFBirth ==='0001-01-01T00:00:00' ? "" : (employeeDetails?.dateOFBirth?.substring(0, 10) ?? new Date())
              }
              onChange={(e) =>
                handleOnChangePersonalInfoFields("dateOFBirth", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>
       
        <FormGroup row>
          <Label sm={4} style={fontSize}>
           Address
          </Label>
          <Col sm={8}>
            <Input
              type="text"
              value={employeeDetails.postalAddress}
              onChange={(e) =>
                handleOnChangePersonalInfoFields("postalAddress", e.target.value)
              }
              style={inputHeight}
            />
          </Col>
        </FormGroup>


        <FormGroup check row className="text-center">
          <Button
            color=""
            className="btn-admin-settings"
            onClick={formValidationOnSubmitAddemp}
          >
            Update
          </Button>
          &nbsp;
          <Button
            color=""
            className="btn-cancel"
            // onClick={() => handleClickEdit("")}
          >
            Cancel
          </Button>
        </FormGroup>
      </Form>
    </Fragment>
  )
  // setSrc() 
  //console.log("Employee Profile Top Row");
  //console.log(selectEmp)      formData.append("UploadPolicyFile",attachment);
      // formData.append("UploadPolicyFilePath",attachment.name);
  return (
    
    <Card style={{ borderRadius: "5px" }}>
      <CardBody>
        {/* check whether the props has the value */}
        <Container>
        <Form>
        {selectEmp.value ? (
          <Row form>
            <Col>
              <div className="profile-view">
                <div className="profile-img-wrap">
                  <div className="profile-img">
                    {/* <a href="#"> */}
                    <label htmlFor="photo-upload" className="custom-file-upload fas">
                   
                    <div className="img-wrap img-upload" >
                    {/* <img for="photo-upload"
                      alt=""
                      src={selectEmp.value.profilePicture == null ||  selectEmp.value.profilePicture=='undefined'? (require("../../../img/employee/user.png")) : (require("../../../img/employee/" + selectEmp.value.profilePicture))}
                    /> */}
                    {/* <img for="photo-upload"
                      alt=""
                      src={selectEmp.value.profilePicture == null || selectEmp.value.profilePicture == "null" || selectEmp.value.profilePicture=='undefined'? (require("../../../img/employee/user.png")) : `${process.env.PUBLIC_URL}` + '/img/employee/' + selectEmp.value.profilePicture}
                    /> */}
                  {/*  {selectEmp.value.profilePicture == null ||  selectEmp.value.profilePicture=='undefined'?(<img for="photo-upload"
                      alt=""
                      src={selectEmp.value.profilePicture == null ||  selectEmp.value.profilePicture=='undefined'? (require("../../../img/employee/user.png")) : (require("../../../img/employee/" + selectEmp.value.profilePicture))}
                    />) :(null)} */}
              
                    <img src={selectEmp.value.profilePicture == null || selectEmp.value.profilePicture== "null" ||selectEmp.value.profilePicture =='undefined'? (require(`../../../img/employee/user.png`)) : (`http://13.68.220.177:63306/wwwroot/UploadedPhotos/ProfilePicture/${selectEmp.value.profilePicture}`)} alt="Uploaded" width="200" />
                      {/* <Avatar 
        alt="User Avatar" 
        src="https://niraconnect.nirasystems.com:8080/wwwroot/UploadedPhotos/ProfilePicture/24ed109e-7fda-4708-b15f-022a5cf971be.png" 
        sx={{ width: 56, height: 56 }} // Adjust size if needed
      /> */}
                     <input id="photo-upload" type="file" accept="image/png" onChange={(e) =>onChange(e)}/> 
                    </div>
                    </label>
                    {/* </a> */}
                  </div>
                </div>
                <div className="profile-basic">
                  <div className="row">
                    <div className="col-md-7">
                      <div className="">
                        <h3 className="user-name m-t-0 mb-0">
                          {selectEmp.value.employeeName}
                        </h3>
                        <h6 className="text-muted">
                          {selectEmp.value.designationName}
                        </h6>
                        <div className="staff-id">
                          UserName &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; {selectEmp.value.userName}
                        </div>
                        <div className="staff-id">
                        <a style={{color: "#007bff"}} href="#" onClick={toggleModal}>
          Change Password
        </a>
                        </div>
                        <div className="staff-id">
                          Gender &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; {selectEmp.value.gender}
                        </div>
                        <div className="staff-id">
                          Employee Code :&nbsp; {selectEmp.value.employeeCode}
                        </div>
                        <div className="staff-id">
                          Work Premise &nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; {selectEmp.value.workingPremiseType}
                        </div>
                        <div className="staff-id">
                          Date of Join &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; {selectEmp.value.dateOfJoin ==='0001-01-01T00:00:00' ? "Nil" : Moment(selectEmp.value.dateOfJoin).format("DD MMM YYYY")}
                        </div>
                        <div className="staff-id">
                         Confirmation Date :&nbsp; {selectEmp.value.confirmedDate ==='0001-01-01T00:00:00' ? "Nil" : Moment(selectEmp.value.confirmedDate).format("DD MMM YYYY")}
                        </div>
                      {selectEmp.value.isActive == false ? (<div className="staff-id">
                         Resigned Date &nbsp;&nbsp;&nbsp;:&nbsp; {selectEmp.value.resignedDate ==='0001-01-01T00:00:00' ? "Nil" : Moment(selectEmp.value.resignedDate).format("DD MMM YYYY")}
                        </div>) : (null)}  
                        <div className="small doj text-muted">
                          (Image size less than 5kb)
                        </div>
                      
                        {isbuttonVisible == true ? (<div><Button onClick={handleupdateprofilepic}>Update</Button></div>) :null}
                        <div className="staff-msg">
                          <a className="btn btn-custom" href="chat.html">
                            {/* Send Message */}
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5 profile-info-left">
                      <br/><br/>
                     {isdetailsedit === false ? (<ul className="personal-info">
                        <li>
                          <div className="title">Phone:</div>
                          <div className="text">
                            <span className="link-text">
                              {selectEmp.value.mobileNumber!="null"?selectEmp.value.mobileNumber:"-"}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="title">Email:</div>
                          <div className="text">
                            <span className="link-text">
                              {selectEmp.value.primaryMailId}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="title">Birthday:</div>
                          <div className="text">
                          {selectEmp.value.dateOFBirth ==='0001-01-01T00:00:00' ? "Nil" : Moment(selectEmp.value.dateOFBirth).format("DD-MM-YYYY")}                          
                          </div>
                        </li>
                        <li>
                          <div className="title">Address:</div>
                          <div className="text">
                          {selectEmp.value.postalAddress!="null"?selectEmp.value.postalAddress:"-"}
                          </div>
                        </li>
                        <li style={{"display":"none"}}>
                          <div className="title">Gender:</div>
                          <div className="text">Male</div>
                        </li>
                        <li style={{"display":"none"}}>
                          <div className="title">Reports to:</div>
                          <div className="text">
                            <div className="avatar-box">
                              <div className="avatar avatar-xs">
                                <img
                                  src={require(`../../../img/employee/avatar-01.jpg`)}
                                  alt=""
                                />
                              </div>
                            </div>
                            <a href="profile.html" className="link-text">
                              Jeffery Lalor
                            </a>
                          </div>
                        </li>
                      </ul>) : (personaldetails)} 
                    </div>
                  </div>
                </div>
                <div className="pro-edit">
                  <span className="edit-icon">
                    {isdetailsedit === false ? (<i className="fas fa-pencil-alt" onClick={handledetailseditable}></i>):(
                      <i className="fas fa-times" onClick={handledetailseditable}></i>
                    )}
                    
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        ) : null}

<ChangePasswordModal
            openModal={openModal}
            toggleModal={toggleModal}
            onchangeInputField={onchangeInputField}
            handleSubmitPassword={handleSubmitPassword}
            currentpassword={selectEmp.length === 0 ? "" : selectEmp.value.password}
          ></ChangePasswordModal>
        </Form>
        <Notifications notifications={error}></Notifications>
    </Container>
      </CardBody>
    </Card>

  );
});

export default EmpProfileViewToCard;
